import { render, staticRenderFns } from "./PassportIndicatorEditBox.vue?vue&type=template&id=0c3fece9&scoped=true"
import script from "./PassportIndicatorEditBox.vue?vue&type=script&lang=js"
export * from "./PassportIndicatorEditBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3fece9",
  null
  
)

export default component.exports